// apps/client/src/api/transactions.ts
import {
  TransactionActivityAllocation,
  TransactionAllocateResponse,
  TransactionsListRequestBody,
  TransactionsListResponse,
} from '@avanzu/types';
import { apiClient } from './apiClient';

/**
 * Fetch transactions for a research plan
 */
export const fetchTransactions = async (
  organisationId: string,
  params?: TransactionsListRequestBody
): Promise<TransactionsListResponse> => {
  const queryParams = new URLSearchParams();

  if (params?.activityId) queryParams.append('activityId', params.activityId);
  if (params?.allocationStatus) queryParams.append('allocationStatus', params.allocationStatus);
  if (params?.startDate) queryParams.append('startDate', params.startDate);
  if (params?.endDate) queryParams.append('endDate', params.endDate);
  if (params?.type) queryParams.append('type', params.type);
  if (params?.page) queryParams.append('page', params.page.toString());
  if (params?.pageSize) queryParams.append('pageSize', params.pageSize.toString());
  if (params?.sortBy) queryParams.append('sortBy', params.sortBy);

  const queryString = queryParams.toString();
  const url = `/organisations/${organisationId}/transactions/${queryString ? `?${queryString}` : ''}`;
  const response = await apiClient.get(url);
  const data: TransactionsListResponse = await response.json();

  return data;
};

/**
 * Save transaction allocations
 */
export const saveTransactionAllocations = async (
  organisationId: string,
  projectId: string,
  transactionId: string,
  allocations: Omit<TransactionActivityAllocation, 'id' | 'createdAt' | 'updatedAt'>[],
  options?: { applySalaryLoading?: boolean }
): Promise<TransactionAllocateResponse> => {
  const response = await apiClient.post(
    `/organisations/${organisationId}/transactions/${transactionId}/allocations`,
    {
      allocations,
      projectId,
      ...(options?.applySalaryLoading ? { applySalaryLoading: true } : {}),
    }
  );
  if (!response.ok) {
    const errorData = await response.json();
    const errorMessage = errorData?.error || 'An unexpected error occurred';
    throw new Error(errorMessage);
  }
  const data: TransactionAllocateResponse = await response.json();
  return data;
};

/**
 * Save transaction allocations
 */
export const removeTransactionAllocations = async (
  organisationId: string,
  transactionId: string
): Promise<TransactionAllocateResponse> => {
  const endpoint = `/organisations/${organisationId}/transactions/${transactionId}/allocations`;
  const response = await apiClient.delete(endpoint);
  if (!response.ok) {
    const errorData = await response.json();
    const errorMessage = errorData?.error || 'An unexpected error occurred';
    throw new Error(errorMessage);
  }
  const data: TransactionAllocateResponse = await response.json();
  return data;
};
